import "./utilities_namespace.js";

// SOURCE: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions

window.Sparkle ??= {};
window.Sparkle.Utilities ??= {};

window.Sparkle.Utilities.escapeForRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
